import { Component, Input, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { ChartType } from "chart.js";
import { ChartDataSets, ChartOptions } from "chart.js";
import { MultiDataSet, Label, Color, Colors } from "ng2-charts";
import * as pluginDataLabels from "chartjs-plugin-datalabels";

@Component({
  selector: 'app-chart-management',
  templateUrl: './chart-management.component.html',
  styleUrls: ['./chart-management.component.scss']
})
export class ChartManagementComponent implements AfterContentChecked {

  @Input() dataChart: any;
  public labels: any;
  public values: any;

  public barChartOptions2: ChartOptions = {
    responsive: true,
    // Dynamic theming.
    scales: {
      xAxes: [
        {
          gridLines: {
            color: "rgba(0, 0, 0, 0)",
            drawOnChartArea: false
          },
          ticks: {
            display: true
          }
        }
      ],
      yAxes: [
        {
          gridLines: {
            color: "transparent"
          },
          ticks: {
            display: false
          }
        }
      ]
    },
    plugins: {
      datalabels: {
        color: "transparent",
        anchor: "end",
        align: "left",
        font: {
          size: 19
        }
      }
    }
  };

  public barChartLabels2: Label[] = [
    // "0 - 120",
    // "120 - 180",
    // "180 - 360",
    // "360 - 720",
    // "+720"
  ];
  public barChartType2: ChartType = "bar";
  public barChartLegend2 = false;
  public barChartPlugins2 = [pluginDataLabels];

  barChartColors2: Color[] = [
    {
      borderColor: "gray",
      backgroundColor: ["#00AA8D", "#00AA8D", "#00AA8D", "#00AA8D", "#00AA8D"]
    }
  ];

  public barChartData2: ChartDataSets[] = [
    {
      barThickness: 50,
      barPercentage: 0.5,
      showLine: false,
      data: this.dataChart,
      label: "%"
    }
  ];

  constructor() { }

  ngAfterContentChecked() {
    const { values, groups } = this.dataChart;
    this.values = values || [];
    this.labels = groups || [];
    this.barChartData2[0].data = this.values;
    this.barChartLabels2 = this.labels;
  }

}
